/*eslint-disable */
var BrowserDetect = {
  init: function () {
    this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
    this.version =
      this.searchVersion(navigator.userAgent) ||
      this.searchVersion(navigator.appVersion) ||
      "an unknown version";
    this.OS = this.searchString(this.dataOS) || "an unknown OS";
  },
  searchString: function (data) {
    for (var i = 0; i < data.length; i++) {
      var dataString = data[i].string;
      var dataProp = data[i].prop;
      this.versionSearchString = data[i].versionSearch || data[i].identity;
      if (dataString) {
        if (dataString.indexOf(data[i].subString) != -1)
          return data[i].identity;
      } else if (dataProp) return data[i].identity;
    }
  },
  searchVersion: function (dataString) {
    var index = dataString.indexOf(this.versionSearchString);
    if (index == -1) return;
    return parseFloat(
      dataString.substring(index + this.versionSearchString.length + 1)
    );
  },
  dataBrowser: [
    {
      string: navigator.userAgent,
      subString: "Chrome",
      identity: "Chrome",
    },
    {
      string: navigator.userAgent,
      subString: "OmniWeb",
      versionSearch: "OmniWeb/",
      identity: "OmniWeb",
    },
    {
      string: navigator.vendor,
      subString: "Apple",
      identity: "Safari",
      versionSearch: "Version",
    },
    {
      prop: window.opera,
      identity: "Opera",
      versionSearch: "Version",
    },
    {
      string: navigator.vendor,
      subString: "iCab",
      identity: "iCab",
    },
    {
      string: navigator.vendor,
      subString: "KDE",
      identity: "Konqueror",
    },
    {
      string: navigator.userAgent,
      subString: "Firefox",
      identity: "Firefox",
    },
    {
      string: navigator.vendor,
      subString: "Camino",
      identity: "Camino",
    },
    {
      // for newer Netscapes (6+)
      string: navigator.userAgent,
      subString: "Netscape",
      identity: "Netscape",
    },
    {
      string: navigator.userAgent,
      subString: "MSIE",
      identity: "Explorer",
      versionSearch: "MSIE",
    },
    {
      //IE11 or later
      string: navigator.userAgent,
      subString: "Trident/7.0",
      identity: "Explorer",
      versionSearch: "rv",
    },
    {
      string: navigator.userAgent,
      subString: "Gecko",
      identity: "Mozilla",
      versionSearch: "rv",
    },
    {
      // for older Netscapes (4-)
      string: navigator.userAgent,
      subString: "Mozilla",
      identity: "Netscape",
      versionSearch: "Mozilla",
    },
  ],
  dataOS: [
    {
      string: navigator.platform,
      subString: "Win",
      identity: "Windows",
    },
    {
      string: navigator.platform,
      subString: "Mac",
      identity: "Mac",
    },
    {
      string: navigator.userAgent,
      subString: "iPhone",
      identity: "iPhone/iPod",
    },
    {
      string: navigator.userAgent,
      subString: "Mobi",
      identity: "Mobile",
    },
    {
      string: navigator.platform,
      subString: "Linux",
      identity: "Linux",
    },
  ],
};
BrowserDetect.init();

var Browser = {
  identifiers: {
    chrome: function () {
      return BrowserDetect.browser == "Chrome";
    },
    firefox: function () {
      return BrowserDetect.browser == "Firefox";
    },
    safari: function () {
      return BrowserDetect.browser == "Safari";
    },
    ie: function () {
      return BrowserDetect.browser == "Explorer";
    },
    edge: function () {
      return navigator.userAgent.match(/Edge/i);
    },
    mobile: function () {
      return navigator.userAgent.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i
      );
    },
    iphone: function () {
      return navigator.userAgent.match(/iPhone/i);
    },
    android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    ipad: function () {
      return navigator.userAgent.match(/iPad/i);
    },
    tablet: function () {},
    phone: function () {},
  },

  abilities: {
    webgl: function () {
      var scope = this;
      //solution from: https://github.com/mrdoob/three.js/blob/master/examples/js/Detector.js
      //as Modernizr only employs a "soft" check (doesnt actually create context)
      if (this._webgl !== undefined) {
        return this._webgl;
      }
      return (function () {
        try {
          var canvas = document.createElement("canvas");
          scope._webgl =
            !!window.WebGLRenderingContext &&
            (canvas.getContext("webgl") ||
              canvas.getContext("experimental-webgl"));
        } catch (e) {
          scope._webgl = false;
        }
        return scope._webgl;
      })();
    },
    easy: function () {
      //If webgl is enabled easy should be allowed
      return this.webgl();
    },
    canvas: function () {
      return Modernizr.canvas;
    },
    css3d: function () {
      return Modernizr.csstransforms3d;
    },
    flash: function () {
      if (navigator.mimeTypes["application/x-shockwave-flash"]) {
        return true;
      } else if (window.ActiveXObject) {
        try {
          var test = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
          return true;
        } catch (e) {}
      }
      return false;
    },
    equirectangular: function () {
      return this.webgl() && this.canvas();
    },
  },

  is: function (identifierString) {
    var identifiers = identifierString.split(" ");

    for (var i in identifiers) {
      if (!this.checkIdentifier(identifiers[i].toLowerCase())) {
        return false;
      }
    }

    return true;
  },

  checkVersion: function (versionSearch) {
    var versionString = Browser.getBrowserData().version + "";
    for (var i in versionSearch) {
      if (versionSearch[i] != versionString[i]) {
        return false;
      }
    }

    return true;
  },

  checkIdentifier: function (identifier) {
    var matches = /([a-z]+)([0-9.]+)/.exec(identifier);

    if (matches) {
      identifier = matches[1];
      if (!this.checkVersion(matches[2])) {
        return false;
      }
    }

    return this.identifiers[identifier]();
  },

  can: function (abilityString) {
    var abilities = abilityString.split(" ");

    for (var i in abilities) {
      if (!this.abilities[abilities[i].toLowerCase()]()) {
        return false;
      }
    }

    return true;
  },

  getBrowserData: function () {
    return {
      browser: BrowserDetect.browser,
      version: BrowserDetect.version,
      os: BrowserDetect.OS,
    };
  },

  getVersion: function () {
    var ios =
      (Browser.is("iphone") || Browser.is("ipad")) &&
      window.navigator.userAgent.match(/[0-9]+_[0-9]+/)[0].split("_"); //IOS DEVICE VERSION
    return parseFloat(
      Browser.is("android")
        ? (/Chrome\/(\d+)/g.exec(navigator.userAgent) || [])[1]
        : ios[0] + "." + ios[1]
    );
  },

  recommenedBrowser: function () {
    return Browser.is("android")
      ? "Chrome or Firefox"
      : Browser.is("iphone") || Browser.is("ipad")
      ? "Safari"
      : "mobile";
  },
};

export default Browser;
